<template>
	<div class="receive-container">
		<div class="head">ADDRESS</div>
		
		<h6 class="title" v-if="formDate.type==1">Add a new shipping address</h6>
		<h6 class="title" v-else>Edit shipping address</h6>


		<div class="form">
			<div class="form-item clearfix">
				
				<div class="input-block">
					<input class="input" type="text" placeholder="First Name："  v-model="formDate.first_name"/>
				</div>
			</div>
			<div class="form-item clearfix">
				
				<div class="input-block">
					<input class="input" type="text" placeholder="Last Name："  v-model="formDate.last_name"/>
				</div>
			</div>
			<div class="form-item clearfix">
				
				<div class="input-block">
					<input class="input" type="text"  placeholder="Email：" v-model="formDate.email"/>
				</div>
			</div>

			<div class="form-item clearfix">
				
				<div class="input-block">
					<input class="input" type="text" placeholder="Phone："  v-model="formDate.phone"/>
				</div>
			</div>

			<div class="form-item clearfix">
				
				<div class="input-block">
					<input class="input" type="text" placeholder="Postcode："  v-model="formDate.postcode"/>
				</div>
			</div>

			<div class="form-item clearfix">
				
				<div class="input-block">
					<input class="input" type="text" placeholder="Address："  v-model="formDate.address"/>
				</div>
			</div>

			<div class="form-item clearfix" v-if="addressDate" style="border:none;">
				
				<el-select v-model="formDate.country" placeholder="Country">
					<el-option 
					  :label="item.label" 
					  :value="item.value" 
					  :key="item.value" 
					  v-for="item in addressDate"
					>
					 </el-option>
				</el-select>
			</div>
			
			<div class="form-item clearfix clear-border">
				<div class="input-block">
					<el-button type="success" @click="save" >Confirm</el-button>
					<button type="button"  @click="formDate.default==1?formDate.default=2:formDate.default=1">
						<i class="oval" :class="{'on':formDate.default  == 1}"></i> <!-- 选中类 on -->
						<span >Default address</span>
					</button>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>

    import { Toast } from 'vant';

   import addressDate from '../../static/address.json';

	export default {
		data () {
			return {
				addressDate,
				isProvince: false,
				provinceId: 0,
				provinceArr: [],
				isCity: false,
				formDate:{
					type:1, 	//1添加 2编辑
					first_name:"",
					last_name:"",
					phone:"",
					email:"",
					address:"",
					country:"",
					default:1  //1默认地址 2正常
				},

			}
		},
		mounted () {

		    var app = this;

			if(this.$route.params.data){

				this.formDate = JSON.parse(this.$route.params.data);

				this.formDate.type = 2;
			}
		},
		methods: {
			showToast(msg){

				this.global_variable.showToast(msg)
			},
			save(){
                var app= this;

                this.formDate.country  = this.addressDate[this.formDate.country].label;
				
                this.$api("/user/addAddress", this.formDate ,"POST").then(function(res){

                    if(res.status=="200"){ 

                    	app.showToast(res.msg)

				        setTimeout(function(){
                            app.$router.go(-1)
				        },1000) 
                    }

	            })
			},
			inputFocus (name) {
				this[name] = true
			},
			inputBlur (name) {
				setTimeout(() => {
					this[name] = false
				}, 200)
			},
		}
	}
</script>

<style lang="less" >
.receive-container{
	
	.form {
		.input-block{
			padding-left:20px;
		}
		.form-item {
			width: 580px;
			border-radius: 6px;
			border: 1px solid #e6e6e6;
			box-sizing: border-box;
			.form-inline {
				margin-right: 15px;
				border-radius: 6px;
				border: 1px solid #e6e6e6;
				box-sizing: border-box;
				.input-inline {
					width: 118px;
					margin-right: 0;
				}
			}
			.input {
				padding-left: 0;
				border: none;
			}
		}

		.clear-border {
			border-radius: 0px;
			border: none;
		}
		.oval {
			width: 20px;
			height: 20px;
			margin-left: 55px;
			margin-right: 12px;
			border-radius: 50%;
			border: 1px solid #dcdddd;
			box-sizing: border-box;
			vertical-align: middle;
			display: inline-block;
		}
		.oval.on {
			    background-color: #fff;
			    border: 5px solid #90c31f;
		}
	}
	.title {
		font-size:16px;
		padding-bottom:20px;
	}

}


@media screen and (max-width:768px) {
    
    .receive-container{
        .title{
        	font-size:12px;
        }
    	
		.form{
			.form-label{
				display:none;
			}

			.form-item{
				width:100%;
				.input{
					padding-left:10px;
					font-size:12px;
				}
				.form-inline{
					margin-right:0;
					margin-bottom:10px;
					&:last-of-type{
						margin-bottom:0;
					}
					.input-inline{
						width:100%;
					}
				}
				.input-block{
					padding-left:0px;
					font-size:12px;
				}
			}
		}
    }
	
}
</style>



// WEBPACK FOOTER //
// src/components/Receive.vue